import { BaseModel } from "sjs-base-model";
import AgentModel from "./creditoNet/AgentModel";

export default class SimulazioneCreditoNetTableModel extends BaseModel {
    public readonly idCreditoNet: number = 0;
    public readonly idSalary: number = 0;
    public readonly taxCode: string = "";
    public readonly name: string = "";
    public readonly date: string = "";
    public readonly amount: number = 0;
    public readonly agent: AgentModel = new AgentModel({});
    public readonly isExpired: boolean = false;

    constructor(data: Partial<SimulazioneCreditoNetTableModel>) {
        super();

        this.update(data);
    }
}
